/*
 * @Author: syyoon@yongtrim.com
 * @Date: 2018-08-07 11:37:02
 * @Last Modified by: syyoon@yongtrim.com
 * @Last Modified time: 2019-01-20 03:19:46
 */

import _ from "lodash";

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ENV } from "../env/env";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Celeb } from "../models/celeb.model";
import { TransService } from "./trans.service";

@Injectable()
export class CelebService {
  private url = `${ENV.SERVER_URL}/${ENV.API_PATH}/celebs`;

  private _bookmarkCeleb: BehaviorSubject<Celeb> = new BehaviorSubject(null);
  private _updatedCeleb: BehaviorSubject<Celeb> = new BehaviorSubject(null);

  favoriteCelebs: Celeb[];

  constructor(private transService: TransService, private http: HttpClient) {}

  createCeleb(data) {
    return this.http.post(`${this.url}?lang=${this.transService.lang}`, data);
  }

  /**
   * category:
   * search:
   * type: ADMIN, NEWSTAR, FAVORITE, VIEW
   * filter: group, newbie, group-GROUPID
   */
  getCelebs(
    page: number,
    category: string,
    search: string,
    type: string,
    filter?: string
  ) {
    return this.http.get(
      `${this.url}?page=${page}&c=${category || ""}&s=${search ||
        ""}&type=${type || ""}&filter=${filter || ""}&lang=${
        this.transService.lang
      }`
    );
  }

  getCeleb(id: string) {
    return this.http.get(`${this.url}/${id}?lang=${this.transService.lang}`);
  }

  updateCeleb(id: string, data) {
    return this.http.put(
      `${this.url}/${id}?lang=${this.transService.lang}`,
      data
    );
  }

  deleteCeleb(id: string) {
    return this.http.delete(`${this.url}/${id}?lang=${this.transService.lang}`);
  }

  setUser(id: string, userId: string) {
    return this.http.put(
      `${this.url}/${id}/set-user?lang=${this.transService.lang}`,
      {
        user: userId
      }
    );
  }

  addMember(id: string, celebId: string) {
    return this.http.put(
      `${this.url}/${id}/add-member?lang=${this.transService.lang}`,
      {
        member: celebId
      }
    );
  }

  removeMember(id: string, celebId: string) {
    return this.http.put(
      `${this.url}/${id}/remove-member?lang=${this.transService.lang}`,
      {
        member: celebId
      }
    );
  }

  bookmarkCeleb(id: string, enable: boolean) {
    return this.http.put(
      `${this.url}/${id}/bookmark?lang=${this.transService.lang}`,
      {
        enable: enable
      }
    );
  }

  claps(id: string, count: number) {
    return this.http.put(
      `${this.url}/${id}/claps?lang=${this.transService.lang}`,
      {
        count: count
      }
    );
  }

  views(id: string) {
    return this.http.get(
      `${this.url}/${id}/views?lang=${this.transService.lang}`
    );
  }

  notifyBookmarkCeleb(celeb: Celeb) {
    this._bookmarkCeleb.next(celeb);
  }

  get bookmarkedCeleb$() {
    return this._bookmarkCeleb.asObservable();
  }

  notifyUpdatedCeleb(celeb: Celeb) {
    this._updatedCeleb.next(celeb);
  }

  get updatedCeleb$() {
    return this._updatedCeleb.asObservable();
  }

  fetchFavortes() {
    return this.getCelebs(1, "", "", "FAVORITE").map(res => {
      if (res["payload"]) {
        this.favoriteCelebs = res["payload"].docs;
      } else {
        this.favoriteCelebs = [];
      }
      return this.favoriteCelebs;
    });
  }

  isFavorite(celebId: string) {
    return _.find(this.favoriteCelebs, f => f._id === celebId);
  }
}



// WEBPACK FOOTER //
// ./src/services/celeb.service.ts